import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
    createMuiTheme,
    MuiThemeProvider as MaterialUIThemeProvider
} from "@material-ui/core/styles";

import breakpoints from "core/breakpoints";

export const gridItemSpacing = ({
    mobileMaxPadding,
    tabletMaxPadding,
    desktopMinPadding
}) => {
    const mobileMax = useMediaQuery(
        `(min-width:${breakpoints.zero.rem}) and (max-width: ${breakpoints.beforeTablet.rem})`
    );

    const tabletMax = useMediaQuery(
        `(min-width:${breakpoints.tablet.rem}) and (max-width: ${breakpoints.beforeDesktop.rem})`
    );

    const desktopMin = useMediaQuery(`(min-width:${breakpoints.desktop.rem})`);

    if (mobileMax) {
        return mobileMaxPadding;
    } else if (tabletMax) {
        return tabletMaxPadding;
    } else if (desktopMin) {
        return desktopMinPadding;
    }
    return;
};

export const themeStyles = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 0,
            md: breakpoints.tablet.px,
            lg: breakpoints.desktop.px,
            xl: 1440
        }
    }
});

export const MuiThemeProvider = ({ children }) => {
    return (
        <MaterialUIThemeProvider theme={themeStyles}>
            {children}
        </MaterialUIThemeProvider>
    );
};
